import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard to enforce supplier plan validity.
 * Redirects to /assinar if plan is not active.
 * Applied on authenticated layout children (not on /assinar itself).
 */
export const planGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const planStatus = authService.getPlanStatus()();

  if (!planStatus) {
    // Plan status unknown (e.g. after page refresh) — allow through;
    // the dashboard banner will prompt the supplier to subscribe.
    return true;
  }

  if (planStatus.is_blocked) {
    return router.createUrlTree(['/assinar']);
  }

  if (!planStatus.plan_active) {
    return router.createUrlTree(['/assinar']);
  }

  return true;
};
